import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Outlet } from 'react-router-dom';

import Header from '../header/header.component';
import Footer from '../footer/footer.component';

import { Container, Stack } from '@mui/material';

const theme = createTheme({
    typography: {
        allVariants: {
            fontFamily: "'Montserrat', sans-serif"
        }
    },
    palette: {
        primary: {
            main: '#002A4D'
        },
        green: {
            main: '#4CA341'
        },
        yellow: {
            main: '#FFAE07'
        },
        red: {
            main: '#DA1F33'
        },
        white: {
            main: '#FFFFFF'
        }
    }
});

const pageContent = {
    style: {
        height: 'calc(100vh - 140px)' // Header and Footer Height is 140px.
    }
};

const PageLayoutExternal = () => {
    return (
        <Container sx={{ fontFamily: "'Montserrat', sans-serif" }} disableGutters maxWidth={false}>
            <ThemeProvider theme={theme}>
                <div className="wrapper-page">
                    <Stack direction={'column'}>
                        <div>
                            <Header />
                        </div>
                        <div style={pageContent.style}>
                            <Outlet />
                        </div>
                        <div>
                            <Footer />
                        </div>
                    </Stack>
                </div>
            </ThemeProvider>
        </Container>
    );
};

export default PageLayoutExternal;
